/**
 * Pavline Streetwear — Premium Diwali Animation Experience
 * Authentic Diwali Firecracker Sounds & Warm Ambient Festive Music
 * Integrates with Shopify Online Store 2.0 & Kalles Theme
 */

(function () {
  'use strict';

  // Prevent multiple initializations
  if (window.__pavlineDiwaliInit) return;
  window.__pavlineDiwaliInit = true;

  var config = window.PavlineDiwaliConfig || {
    enabled: true,
    soundDefault: true,
    soundUrl: '',
    bgmUrl: '',
    sparkles: true,
    fireworks: true,
    bannerGlow: true,
  };

  if (!config.enabled) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ==========================================================================
     AUDIO ENGINE: Authentic Firecracker Crackles + Warm Acoustic Ambient Music
     ========================================================================== */
  var AudioEngine = {
    bgmAudio: null,
    sfxPool: [],
    poolIndex: 0,
    POOL_SIZE: 6,
    audioContext: null,
    isPlaying: false,
    bgmMuted: false, // controls background music only (does NOT mute button firecrackers)
    hasInteracted: false,
    lastCrackleTime: 0,
    CRACKLE_COOLDOWN_MS: 70,

    init: function () {
      // Audio is ON by default
      var sessionMuted = sessionStorage.getItem('pavline_user_toggled_music');
      if (sessionMuted !== null) {
        this.bgmMuted = sessionMuted === 'true';
      } else {
        this.bgmMuted = false;
        try { localStorage.removeItem('pavline_diwali_bgm_muted'); } catch (e) {}
      }

      this.setupBgm();
      this.setupSfxPool();
      this.unlockAudioContext();
      this.bindAutoplayTriggers();
      this.updateToggleUI();

      // Immediately play on page load without waiting for user interaction
      if (!this.bgmMuted) {
        this.playBgm();
        var self = this;
        [50, 150, 300, 600, 1000, 1800].forEach(function (delay) {
          setTimeout(function () {
            if (!self.bgmMuted && !self.isPlaying) {
              self.playBgm();
            }
          }, delay);
        });
      }
    },

    setupBgm: function () {
      var bgmSrc = config.bgmUrl || 'assets/pavline-diwali-bgm.mp3';
      this.bgmAudio = new Audio();
      this.bgmAudio.src = bgmSrc;
      this.bgmAudio.loop = true;
      this.bgmAudio.preload = 'auto';
      this.bgmAudio.volume = 0.22; // Peaceful, gentle light bells ambient level

      var self = this;
      this.bgmAudio.addEventListener('playing', function () {
        self.isPlaying = true;
        self.updateToggleUI();
      });

      this.bgmAudio.addEventListener('pause', function () {
        self.isPlaying = false;
        self.updateToggleUI();
      });

      if (!this.bgmMuted) {
        this.playBgm();
      }
    },

    // Audio pool for instantaneous firecracker sounds with zero latency or choking
    setupSfxPool: function () {
      var sfxSrc = config.soundUrl || 'assets/pavline-diwali-sparkle.mp3';
      this.sfxPool = [];
      for (var i = 0; i < this.POOL_SIZE; i++) {
        var audio = new Audio();
        audio.src = sfxSrc;
        audio.preload = 'auto';
        audio.volume = 0.85; // Authentic, crisp firecracker volume
        this.sfxPool.push(audio);
      }
    },

    bindAutoplayTriggers: function () {
      var self = this;
      var triggerEvents = [
        'mousemove',
        'pointermove',
        'pointerdown',
        'touchstart',
        'touchmove',
        'wheel',
        'scroll',
        'click',
        'keydown',
        'focus',
        'visibilitychange'
      ];

      function onAnyActivity() {
        self.unlockAudioContext();
        if (!self.bgmMuted && !self.isPlaying) {
          self.playBgm();
        }
        if (self.isPlaying) {
          triggerEvents.forEach(function (evt) {
            window.removeEventListener(evt, onAnyActivity, { capture: true });
            document.removeEventListener(evt, onAnyActivity, { capture: true });
          });
        }
      }

      triggerEvents.forEach(function (evt) {
        window.addEventListener(evt, onAnyActivity, { capture: true, passive: true });
        document.addEventListener(evt, onAnyActivity, { capture: true, passive: true });
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          if (!self.bgmMuted && !self.isPlaying) self.playBgm();
        });
      }
      window.addEventListener('load', function () {
        if (!self.bgmMuted && !self.isPlaying) self.playBgm();
      });

      if (!this.bgmMuted) {
        this.playBgm();
      }
    },

    unlockAudioContext: function () {
      if (!this.audioContext && (window.AudioContext || window.webkitAudioContext)) {
        try {
          var AudioCtx = window.AudioContext || window.webkitAudioContext;
          this.audioContext = new AudioCtx();
        } catch (e) {}
      }
      if (this.audioContext && this.audioContext.state === 'suspended') {
        this.audioContext.resume().catch(function () {});
      }
    },

    playBgm: function () {
      if (this.bgmMuted || !this.bgmAudio) return;

      var self = this;
      var promise = this.bgmAudio.play();
      if (promise !== undefined) {
        promise
          .then(function () {
            self.isPlaying = true;
            self.updateToggleUI();
          })
          .catch(function () {
            self.isPlaying = false;
            self.updateToggleUI();
          });
      }
    },

    pauseBgm: function () {
      if (this.bgmAudio) {
        this.bgmAudio.pause();
      }
      this.isPlaying = false;
      this.updateToggleUI();
    },

    // Toggle Background Music ONLY (does NOT affect button firecrackers)
    toggle: function () {
      this.unlockAudioContext();
      if (!this.bgmMuted) {
        this.bgmMuted = true;
        try { sessionStorage.setItem('pavline_user_toggled_music', 'true'); } catch (e) {}
        this.pauseBgm();
      } else {
        this.bgmMuted = false;
        try { sessionStorage.setItem('pavline_user_toggled_music', 'false'); } catch (e) {}
        this.playBgm();
      }
      this.updateToggleUI();
    },

    // Play Authentic Firecracker Sound on Add to Cart & Wishlist Buttons
    // Button sound ALWAYS plays regardless of whether background music is On or Off!
    playFirecrackerSound: function () {
      this.unlockAudioContext();

      // If BGM is enabled and not playing yet, start on this user gesture
      if (!this.bgmMuted && !this.isPlaying && this.bgmAudio) {
        this.playBgm();
      }

      var now = Date.now();
      if (now - this.lastCrackleTime < this.CRACKLE_COOLDOWN_MS) return;
      this.lastCrackleTime = now;

      var played = false;
      if (this.sfxPool && this.sfxPool.length > 0) {
        var audio = this.sfxPool[this.poolIndex];
        this.poolIndex = (this.poolIndex + 1) % this.sfxPool.length;

        try {
          audio.currentTime = 0;
          var p = audio.play();
          if (p !== undefined) {
            var self = this;
            p.then(function () {
              played = true;
            }).catch(function () {
              self.synthesizeRealCracker();
            });
          } else {
            played = true;
          }
        } catch (e) {
          this.synthesizeRealCracker();
        }
      } else {
        this.synthesizeRealCracker();
      }
    },

    // Exact Firecracker Synthesis (Punchy Explosion + Secondary Crackle Pops)
    synthesizeRealCracker: function () {
      this.unlockAudioContext();
      if (!this.audioContext) return;

      try {
        var ctx = this.audioContext;
        var now = ctx.currentTime;

        // 1. Initial Bass Thump & Shockwave (120Hz -> 35Hz drop)
        var subOsc = ctx.createOscillator();
        var subGain = ctx.createGain();
        subOsc.type = 'sine';
        subOsc.frequency.setValueAtTime(130, now);
        subOsc.frequency.exponentialRampToValueAtTime(35, now + 0.18);
        subGain.gain.setValueAtTime(0.5, now);
        subGain.gain.exponentialRampToValueAtTime(0.001, now + 0.22);
        subOsc.connect(subGain);
        subGain.connect(ctx.destination);
        subOsc.start(now);
        subOsc.stop(now + 0.25);

        // 2. Explosive Bang Noise
        var blastLen = Math.floor(ctx.sampleRate * 0.25);
        var blastBuf = ctx.createBuffer(1, blastLen, ctx.sampleRate);
        var blastData = blastBuf.getChannelData(0);
        for (var i = 0; i < blastLen; i++) {
          blastData[i] = (Math.random() * 2 - 1) * Math.exp(-12 * (i / blastLen));
        }
        var blastSource = ctx.createBufferSource();
        blastSource.buffer = blastBuf;
        var blastFilter = ctx.createBiquadFilter();
        blastFilter.type = 'lowpass';
        blastFilter.frequency.setValueAtTime(1200, now);
        blastFilter.frequency.exponentialRampToValueAtTime(200, now + 0.25);
        var blastGain = ctx.createGain();
        blastGain.gain.setValueAtTime(0.45, now);
        blastGain.gain.exponentialRampToValueAtTime(0.001, now + 0.25);
        blastSource.connect(blastFilter);
        blastFilter.connect(blastGain);
        blastGain.connect(ctx.destination);
        blastSource.start(now);
        blastSource.stop(now + 0.28);

        // 3. Four rapid secondary crackle pops (Patakha lad effect)
        var popTimes = [0.06, 0.11, 0.17, 0.24, 0.32];
        popTimes.forEach(function (offset, idx) {
          var pTime = now + offset;
          var pLen = Math.floor(ctx.sampleRate * 0.05);
          var pBuf = ctx.createBuffer(1, pLen, ctx.sampleRate);
          var pData = pBuf.getChannelData(0);
          for (var j = 0; j < pLen; j++) {
            pData[j] = (Math.random() * 2 - 1) * Math.exp(-35 * (j / pLen));
          }
          var pSrc = ctx.createBufferSource();
          pSrc.buffer = pBuf;
          var pFilter = ctx.createBiquadFilter();
          pFilter.type = 'bandpass';
          pFilter.frequency.setValueAtTime(1500 + idx * 300, pTime);
          var pGain = ctx.createGain();
          pGain.gain.setValueAtTime(0.35 - idx * 0.05, pTime);
          pGain.gain.exponentialRampToValueAtTime(0.001, pTime + 0.06);
          pSrc.connect(pFilter);
          pFilter.connect(pGain);
          pGain.connect(ctx.destination);
          pSrc.start(pTime);
          pSrc.stop(pTime + 0.07);
        });
      } catch (err) {}
    },

    updateToggleUI: function () {
      var btn = document.getElementById('pav-diwali-sound-toggle');
      if (!btn) return;

      var stateSpan = btn.querySelector('.pav-diwali-toggle-state');
      var isAudioActive = !this.bgmMuted;
      if (isAudioActive) {
        btn.classList.add('is-active');
        btn.classList.remove('is-muted');
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', 'Turn Off Background Music');
        if (stateSpan) stateSpan.textContent = 'On';
      } else {
        btn.classList.remove('is-active');
        btn.classList.add('is-muted');
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Turn On Background Music');
        if (stateSpan) stateSpan.textContent = 'Off';
      }
    },
  };

  /* ==========================================================================
     FIRECRACKER & PARTICLE CANVAS ENGINE
     ========================================================================== */
  var ParticleEngine = {
    canvas: null,
    ctx: null,
    width: window.innerWidth,
    height: window.innerHeight,
    ambientParticles: [],
    burstParticles: [],
    animationFrameId: null,
    isRunning: false,
    dpr: Math.min(window.devicePixelRatio || 1, 2),

    colors: [
      '#FFDF73', // Bright Gold
      '#FFD700', // Festive Gold
      '#FFA500', // Golden Orange
      '#FFFFFF', // White Flash
      '#FFF8DC', // Warm Sparkle
      '#EB001B', // Pavline Red
      '#FF334B', // Crimson Spark
    ],

    init: function () {
      if (prefersReducedMotion) return;

      this.canvas = document.getElementById('pav-diwali-canvas');
      if (!this.canvas) {
        this.canvas = document.createElement('canvas');
        this.canvas.id = 'pav-diwali-canvas';
        this.canvas.className = 'pav-diwali-canvas';
        this.canvas.setAttribute('aria-hidden', 'true');
        document.body.appendChild(this.canvas);
      }

      this.ctx = this.canvas.getContext('2d', { alpha: true });
      this.handleResize = this.resize.bind(this);
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.resize();

      if (config.sparkles) {
        this.createAmbientSparkles(window.innerWidth < 768 ? 32 : 65);
      }

      this.start();

      var self = this;
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          self.stop();
        } else {
          self.start();
        }
      });
    },

    resize: function () {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.canvas.width = this.width * this.dpr;
      this.canvas.height = this.height * this.dpr;
      this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    },

    createAmbientSparkles: function (count) {
      this.ambientParticles = [];
      for (var i = 0; i < count; i++) {
        this.ambientParticles.push({
          x: Math.random() * this.width,
          y: Math.random() * this.height,
          radius: Math.random() * 0.9 + 0.5, // Delicate, small stars (0.5px - 1.4px)
          color: this.colors[Math.floor(Math.random() * 4)],
          alpha: Math.random() * 0.35 + 0.35, // Soft, gentle twinkle
          speedY: Math.random() * 0.35 + 0.15,
          speedX: (Math.random() - 0.5) * 0.25,
          twinkleSpeed: Math.random() * 0.035 + 0.015,
          twinkleAngle: Math.random() * Math.PI * 2,
        });
      }
    },

    // Explosive Firecracker Burst at exact coordinates
    burst: function (x, y, isBig) {
      if (prefersReducedMotion || !config.fireworks) return;

      if (typeof x !== 'number' || isNaN(x) || x < 0 || x > this.width) {
        x = this.width * 0.5;
      }
      if (typeof y !== 'number' || isNaN(y) || y < 0 || y > this.height) {
        y = Math.min(this.height * 0.4, 300);
      }

      var count = isBig ? (window.innerWidth < 768 ? 48 : 68) : (window.innerWidth < 768 ? 32 : 50);

      // 1. Central radiant flash
      this.burstParticles.push({
        type: 'flash',
        x: x,
        y: y,
        radius: 8,
        maxRadius: isBig ? 38 : 26,
        color: '#FFFFFF',
        alpha: 0.95,
        decay: 0.09,
      });

      // 2. High-velocity firecracker sparks
      for (var i = 0; i < count; i++) {
        var angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.5;
        var speed = Math.random() * (isBig ? 9.0 : 7.0) + 2.5;
        var color = this.colors[Math.floor(Math.random() * this.colors.length)];

        this.burstParticles.push({
          type: 'spark',
          x: x,
          y: y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          gravity: 0.16,
          friction: 0.942,
          color: color,
          radius: Math.random() * 3.0 + 1.2,
          life: 1.0,
          decay: Math.random() * 0.024 + 0.015,
          trail: [],
          canCrackle: Math.random() > 0.55,
          hasCrackled: false,
        });
      }

      // 3. Shimmering ember shower
      var emberCount = isBig ? 24 : 16;
      for (var j = 0; j < emberCount; j++) {
        var a = Math.random() * Math.PI * 2;
        var s = Math.random() * 3.5 + 0.6;
        this.burstParticles.push({
          type: 'spark',
          x: x,
          y: y,
          vx: Math.cos(a) * s,
          vy: Math.sin(a) * s - 1.2,
          gravity: 0.09,
          friction: 0.965,
          color: '#FFF275',
          radius: Math.random() * 1.8 + 0.8,
          life: 1.25,
          decay: 0.016,
          trail: [],
          canCrackle: false,
          hasCrackled: true,
        });
      }

      if (!this.isRunning) {
        this.start();
      }
    },

    update: function () {
      this.ctx.clearRect(0, 0, this.width, this.height);

      // Ambient golden sparkles
      for (var i = 0; i < this.ambientParticles.length; i++) {
        var p = this.ambientParticles[i];
        p.y -= p.speedY;
        p.x += Math.sin(p.twinkleAngle) * 0.4 + p.speedX;
        p.twinkleAngle += p.twinkleSpeed;

        var currentAlpha = p.alpha * (0.6 + 0.4 * Math.sin(p.twinkleAngle));

        if (p.y < -10) {
          p.y = this.height + 10;
          p.x = Math.random() * this.width;
        }
        if (p.x < -10) p.x = this.width + 10;
        if (p.x > this.width + 10) p.x = -10;

        this.drawSparkle(p.x, p.y, p.radius, p.color, currentAlpha);
      }

      // Firecracker burst particles
      for (var k = this.burstParticles.length - 1; k >= 0; k--) {
        var b = this.burstParticles[k];

        if (b.type === 'flash') {
          b.radius += (b.maxRadius - b.radius) * 0.35;
          b.alpha -= b.decay;
          if (b.alpha <= 0) {
            this.burstParticles.splice(k, 1);
            continue;
          }
          this.ctx.save();
          this.ctx.globalAlpha = Math.max(0, b.alpha);
          this.ctx.strokeStyle = '#FFDF73';
          this.ctx.lineWidth = 1.8;
          this.ctx.beginPath();
          this.ctx.arc(b.x, b.y, b.radius, 0, Math.PI * 2);
          this.ctx.stroke();
          this.ctx.restore();
          continue;
        }

        b.vx *= b.friction;
        b.vy = b.vy * b.friction + b.gravity;
        b.x += b.vx;
        b.y += b.vy;
        b.life -= b.decay;

        if (b.trail.length > 4) b.trail.shift();
        b.trail.push({ x: b.x, y: b.y });

        // Micro-pop crackle sparks
        if (b.canCrackle && !b.hasCrackled && b.life < 0.6) {
          b.hasCrackled = true;
          for (var c = 0; c < 3; c++) {
            var ca = Math.random() * Math.PI * 2;
            var cs = Math.random() * 2.2 + 1.0;
            this.burstParticles.push({
              type: 'spark',
              x: b.x,
              y: b.y,
              vx: Math.cos(ca) * cs,
              vy: Math.sin(ca) * cs,
              gravity: 0.1,
              friction: 0.93,
              color: '#FFFFFF',
              radius: 1.3,
              life: 0.5,
              decay: 0.05,
              trail: [],
              canCrackle: false,
              hasCrackled: true,
            });
          }
        }

        if (b.life <= 0) {
          this.burstParticles.splice(k, 1);
          continue;
        }

        // Draw sparkler trail
        for (var t = 0; t < b.trail.length; t++) {
          var tr = b.trail[t];
          var tAlpha = Math.max(0, (t / b.trail.length) * b.life * 0.45);
          this.drawSparkle(tr.x, tr.y, b.radius * 0.55, b.color, tAlpha);
        }

        var flicker = (Math.sin(b.life * 32) + 1) * 0.5;
        var bAlpha = Math.max(0, b.life * (0.7 + 0.3 * flicker));
        this.drawSparkle(b.x, b.y, b.radius * b.life, b.color, bAlpha);
      }
    },

    drawSparkle: function (x, y, r, color, alpha) {
      if (alpha <= 0.01 || r <= 0.1) return;

      var ctx = this.ctx;
      ctx.save();
      var clampedAlpha = Math.min(Math.max(alpha, 0), 1);
      ctx.globalAlpha = clampedAlpha;

      // Soft ambient glow (subtle)
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(x, y, r * 1.25, 0, Math.PI * 2);
      ctx.fill();

      // Delicate diamond core
      ctx.fillStyle = '#FFFFFF';
      ctx.beginPath();
      ctx.arc(x, y, r * 0.55, 0, Math.PI * 2);
      ctx.fill();

      // Refined 4-point star flare
      ctx.strokeStyle = color;
      ctx.lineWidth = Math.min(0.65, Math.max(0.4, r * 0.35));
      ctx.beginPath();
      ctx.moveTo(x - r * 1.5, y);
      ctx.lineTo(x + r * 1.5, y);
      ctx.moveTo(x, y - r * 1.5);
      ctx.lineTo(x, y + r * 1.5);
      ctx.stroke();

      ctx.restore();
    },

    start: function () {
      if (this.isRunning) return;
      this.isRunning = true;
      var self = this;

      function loop() {
        if (!self.isRunning) return;
        self.update();
        self.animationFrameId = requestAnimationFrame(loop);
      }
      this.animationFrameId = requestAnimationFrame(loop);
    },

    stop: function () {
      this.isRunning = false;
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
    },
  };

  /* ==========================================================================
     INTERACTIONS: Direct Clicks on Add to Cart and Wishlist
     ========================================================================== */
  var Interactions = {
    init: function () {
      this.updateHeaderOffset();
      this.bindScrollTracking();
      this.bindAtcAndWishlistClicks();
      this.bindCartAddEvents();
      this.bindSoundToggle();
      this.enhanceHomepageElements();

      var self = this;
      window.addEventListener('resize', function () {
        self.updateHeaderOffset();
      }, { passive: true });
    },

    // Dynamically calculate header bottom and drop hanging diyas from header on scroll
    updateHeaderOffset: function () {
      var headerEl = document.querySelector('hdt-sticky-header') ||
                     document.querySelector('.hdt-main-header') ||
                     document.querySelector('#shopify-section-sections--17711204859948__header_inline_blocks_xePFbC') ||
                     document.querySelector('#shopify-section-header_inline_blocks_xePFbC') ||
                     document.querySelector('.shopify-section-group-header-group') ||
                     document.querySelector('header');

      var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var isMobile = window.innerWidth < 768;
      var headerBottom = 0;
      var isHeaderHidden = false;

      if (headerEl) {
        var rect = headerEl.getBoundingClientRect();
        var headerSection = headerEl.closest('.hdt-section-header') || headerEl.closest('.shopify-section');
        if (rect.bottom <= 10 || (headerSection && headerSection.classList.contains('shopify-section-header-hidden'))) {
          isHeaderHidden = true;
        } else {
          headerBottom = Math.round(rect.bottom);
        }
      }

      if (scrollY <= 10) {
        // At top of page: include top announcement bar
        var defaultTop = isMobile ? 104 : 134;
        headerBottom = Math.max(headerBottom, defaultTop);
      } else {
        // Scrolled state: header is sticky at top of screen
        var defaultSticky = isMobile ? 58 : 74;
        headerBottom = Math.max(headerBottom, defaultSticky);
      }

      var diyas = document.querySelectorAll('.pav-diwali-hanging-wrapper');
      for (var i = 0; i < diyas.length; i++) {
        var diya = diyas[i];
        if (isHeaderHidden) {
          diya.style.opacity = '0';
          diya.style.transform = 'translateY(-20px)';
          diya.style.pointerEvents = 'none';
        } else {
          diya.style.opacity = '1';
          diya.style.transform = 'translateY(0)';
          if (scrollY > 10) {
            diya.classList.add('is-scrolled');
          } else {
            diya.classList.remove('is-scrolled');
          }
        }
      }

      document.documentElement.style.setProperty('--pav-diwali-header-offset', headerBottom + 'px');
    },

    bindScrollTracking: function () {
      var self = this;
      var ticking = false;
      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            self.updateHeaderOffset();
            ticking = false;
          });
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      this.updateHeaderOffset();
    },

    bindSoundToggle: function () {
      var toggleBtn = document.getElementById('pav-diwali-sound-toggle');
      if (!toggleBtn) return;

      toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        AudioEngine.toggle();
      });

      toggleBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          AudioEngine.toggle();
        }
      });
    },

    // Trigger Firecracker Sound & Sparkles strictly on Add to Cart and Wishlist buttons
    bindAtcAndWishlistClicks: function () {
      var atcAndWishlistSelector = [
        // Add to Cart buttons
        'button[name="add"]',
        'input[type="submit"][name="add"]',
        '.hdt-product-form__submit',
        '.hdt-card-product__btn-ultra',
        '.btn-atc',
        '.button-atc',
        '[data-add-to-cart]',
        '[data-atc-btn]',
        '.shopify-payment-button__button',
        '.hdt-btn-atc',
        'button.product-form__submit',
        // Wishlist buttons
        'hdt-wishlist',
        '[data-wishlist]',
        '[aria-controls="hdt-wishlist-drawer"]',
        '.hdt-wishlist-btn',
        '.wishlist-btn',
        'a[href*="wishlist"]',
        'button[class*="wishlist"]',
        '[class*="wishlist-btn"]',
        '[class*="hdt-wishlist"]'
      ].join(', ');

      document.addEventListener(
        'click',
        function (e) {
          var targetEl = e.target.closest(atcAndWishlistSelector);
          if (!targetEl) {
            // Check button text or aria-label for Add to Cart / Wishlist
            var btnParent = e.target.closest('button, [role="button"], a.btn, a.hdt-btn');
            if (btnParent) {
              var label = ((btnParent.getAttribute('aria-label') || '') + ' ' + (btnParent.innerText || '')).toLowerCase();
              if (label.indexOf('add to cart') !== -1 || label.indexOf('wishlist') !== -1) {
                targetEl = btnParent;
              }
            }
          }
          if (!targetEl) return;

          // Ignore sound toggle widget
          if (targetEl.id === 'pav-diwali-sound-toggle' || targetEl.closest('#pav-diwali-sound-toggle')) {
            return;
          }

          // Exact click coordinates
          var x = e.clientX;
          var y = e.clientY;

          if (!x || !y) {
            var rect = targetEl.getBoundingClientRect();
            x = rect.left + rect.width / 2;
            y = rect.top + rect.height / 2;
          }

          // 1. Trigger Exact Firecracker Burst at Button
          ParticleEngine.burst(x, y, true);

          // 2. Play Exact Firecracker Sound Effect
          AudioEngine.playFirecrackerSound();

          // 3. Shimmer pulse on clicked element
          targetEl.classList.add('pav-diwali-btn-active-sparkle');
          setTimeout(function () {
            targetEl.classList.remove('pav-diwali-btn-active-sparkle');
          }, 600);
        },
        true // Capture phase to guarantee instantaneous execution
      );
    },

    bindCartAddEvents: function () {
      var self = this;

      document.addEventListener('cart:update', function (e) {
        if (e && e.detail && !e.detail.didError && !e.detail.error) {
          self.celebrateCartSuccess();
        }
      });

      if (window.fetch) {
        var originalFetch = window.fetch;
        window.fetch = function () {
          var args = arguments;
          var url = args[0];
          var isCartAdd =
            typeof url === 'string' &&
            (url.indexOf('/cart/add') !== -1 || url.indexOf('cart/add.js') !== -1);

          return originalFetch.apply(this, args).then(function (response) {
            if (isCartAdd && response && response.ok) {
              response
                .clone()
                .json()
                .then(function (data) {
                  if (data && (data.id || data.key || data.items)) {
                    self.celebrateCartSuccess();
                  }
                })
                .catch(function () {
                  self.celebrateCartSuccess();
                });
            }
            return response;
          });
        };
      }
    },

    celebrateCartSuccess: function () {
      var cartIcon = document.querySelector(
        '#CartDrawer-button, [aria-controls="CartDrawer"], a[href*="/cart"], .hdt-mini-cart, .hdt-header-cart'
      );
      if (cartIcon) {
        var rect = cartIcon.getBoundingClientRect();
        cartIcon.classList.remove('pav-diwali-cart-ping');
        void cartIcon.offsetWidth;
        cartIcon.classList.add('pav-diwali-cart-ping');

        ParticleEngine.burst(rect.left + rect.width / 2, rect.top + rect.height / 2, true);
        AudioEngine.playFirecrackerSound();
      }
    },

    enhanceHomepageElements: function () {
      if (!config.bannerGlow) return;
      var hero = document.querySelector(
        '.hdt-slideshow, .hdt-section-slideshow, [data-section-type="slideshow"], #shopify-section-slideshow_EVrUzi'
      );
      if (hero) {
        hero.classList.add('pav-diwali-hero-banner');
      }
    },
  };

  /* ==========================================================================
     BOOTSTRAP
     ========================================================================== */
  function startExperience() {
    AudioEngine.init();
    ParticleEngine.init();
    Interactions.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startExperience);
  } else {
    startExperience();
  }

  window.PavlineDiwali = {
    version: '1.2.0',
    AudioEngine: AudioEngine,
    ParticleEngine: ParticleEngine,
    burst: function (x, y, isBig) {
      ParticleEngine.burst(x, y, isBig);
    },
    toggleMusic: function () {
      AudioEngine.toggle();
    },
  };
})();
